module.exports = __webpack_public_path__ + "static/media/mastercard.f6a43c17.svg";